import angular from 'angular';
import uiRouter from 'angular-ui-router';
import resetPasswordComponent from './resetPassword.component';

let resetPasswordModule = angular.module('resetPassword', [
  uiRouter
])

.component('resetPassword', resetPasswordComponent)
.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";

  $urlRouterProvider.otherwise('/');

  $stateProvider
    .state('main.resetPassword', {
      url: '/resetPassword',
      name: 'main.resetPassword',
      component: 'resetPassword',
      params: {redirect: null}
    });
})
.name;

export default resetPasswordModule;



// WEBPACK FOOTER //
// ./client/app/components/resetPassword/resetPassword.js